import { QueryClient } from "@tanstack/react-query";
import { api, ErreurApi, type Moi } from "./api";

/** Client de requêtes unique, partagé entre React et les gardes du routeur. */
export const requetes = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // Inutile de réessayer une erreur métier (403, 404, 409…) : seul un souci réseau mérite un second essai.
      retry: (tentatives, erreur) => erreur instanceof ErreurApi && erreur.statut === 0 && tentatives < 2,
      refetchOnWindowFocus: true,
    },
  },
});

export const requeteMoi = { queryKey: ["moi"], queryFn: () => api.get<Moi>("/auth/moi"), staleTime: 60_000 } as const;

/**
 * Suivi « en direct » des écrans de dossier côté formateur et organisme (exigence du 04/11/2026) : toute action de
 * l'apprenant (formulaire, test, signature, dépôt, émargement) apparaît en 30 secondes au plus, sans recharger.
 *  - relecture toutes les 15 s, SEULEMENT tant que l'onglet est visible (`refetchIntervalInBackground: false` : TanStack
 *    Query suspend l'intervalle quand la page est cachée) — aucun trafic pour un onglet oublié en arrière-plan ;
 *  - relecture immédiate au retour sur l'onglet (« always » : même si la donnée a moins de 15 s).
 * Plus simple et plus robuste qu'un flux d'événements serveur derrière le mandataire (Traefik), sans état côté serveur.
 */
export const INTERVALLE_SUIVI_MS = 15_000;
export const suiviEnDirect = { refetchInterval: INTERVALLE_SUIVI_MS, refetchIntervalInBackground: false, refetchOnWindowFocus: "always" } as const;
